<div class="main-container">
  @if ((isMobile$ | async) === false) {
    @if (isAuthenticated && !isMenuHidden) {
      <one-desktop-main-navbar
        class="navbar-container"
        [ngClass]="currentMenuPosition === menuPositions.COLLAPSE ? 'navbar-container-collapsed' : 'navbar-container-expand'"
      ></one-desktop-main-navbar>
    }
  }
  <div class="main-content">
    @if (isIspRoute) {
      <one-isp-session-chrome [showLogbackHeader]="shouldShowIspLogbackHeader"></one-isp-session-chrome>
    }
    @if (isAuthenticated && routerUrl !== '/' && !isMenuHidden && !isInspectorHomeRoute) {
      <one-subnav></one-subnav>
    }
    <div
      [class.qp-container-fluid]="hasContainer && isAuthenticated && !isMenuHidden && hasFluidContainer"
      [class.container-solid]="hasContainer && isAuthenticated && !isMenuHidden && !hasFluidContainer"
      [class.no-container]="!hasContainer"
      [class.main-content__page--no-subnav]="isInspectorHomeRoute"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
  @if (isMobile$ | async) {
    @if (isAuthenticated && !isMenuHidden) {
      <div class="main-mobile-menu">
        <one-mobile-main-navbar></one-mobile-main-navbar>
      </div>
    }
  }
  <router-outlet name="popup"></router-outlet>
</div>
